import React, { useMemo } from 'react';
import SidebarItem from '../Sidebar/SidebarItem';
import { useJobs } from 'JobContext';

interface JobStatusSidebarItemProps {
  expandDueToChildren: boolean;
  onHoverIntent: (hasChildren: boolean) => void;
  selected: boolean;
}

const JobStatusSidebarItem: React.FC<JobStatusSidebarItemProps> = ({
  expandDueToChildren,
  onHoverIntent,
  selected,
}) => {
  const { jobs, loading } = useJobs();

  const jobCounts = useMemo(() => {
    if (!jobs || loading) {
      return { inProgress: 0, failed: 0, completed: 0, total: 0 };
    }

    const inProgress = jobs.totalRunning || 0;
    const failed = jobs.totalFailed || 0;
    const completed = jobs.recentlyCompletedJobs?.length || 0;
    const total = inProgress + failed + completed;

    return { inProgress, failed, completed, total };
  }, [jobs, loading]);

  // Only show the sidebar item if there are jobs to display
  if (jobCounts.total === 0) {
    return null;
  }

  return (
    <SidebarItem
      to="/jobs"
      label="Jobs"
      icon="Settings"
      selected={selected}
      expanded={expandDueToChildren}
      onHoverIntent={onHoverIntent}
      badgeCount={{
        info: jobCounts.inProgress,
        error: jobCounts.failed,
        success: jobCounts.completed,
      }}
    />
  );
};

export default JobStatusSidebarItem;
